// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l8-1";
export var messageSideRight = "_l8-2";
export var orderLookupBubbleContainer = "_l8-0";
export var submitButton = "_l8-3";